import { wikiFeatured, wikiTopics, wikiUrl } from "@/lib/tsorigin-wiki";

export type WikiSearchPost = {
  id: string;
  title: string;
  tag: string;
  subtag: string;
  href: string;
  external: boolean;
};

export type SiteCategorySearch = {
  id: string;
  name: string;
  href: string;
  badge: string;
};

export type HighlightSearch = {
  id: string;
  name: string;
  href: string;
  badge: string;
  external?: boolean;
};

export type PageSearch = {
  id: string;
  title: string;
  path: string;
};

function buildWikiPosts(): WikiSearchPost[] {
  const seen = new Set<string>();
  const out: WikiSearchPost[] = [];

  for (let i = 0; i < wikiFeatured.length; i += 1) {
    const w = wikiFeatured[i];
    const href = wikiUrl(w.path);
    if (seen.has(href)) continue;
    seen.add(href);
    out.push({
      id: `wf-${i}`,
      title: w.title,
      tag: w.tag,
      subtag: "Wiki",
      href,
      external: true,
    });
  }

  for (let ti = 0; ti < wikiTopics.length; ti += 1) {
    const topic = wikiTopics[ti];
    for (let li = 0; li < topic.links.length; li += 1) {
      const link = topic.links[li];
      const href = wikiUrl(link.path);
      if (seen.has(href)) continue;
      seen.add(href);
      out.push({
        id: `wt-${ti}-${li}`,
        title: link.title,
        tag: topic.title,
        subtag: "Wiki",
        href,
        external: true,
      });
      if (out.length >= 48) break;
    }
    if (out.length >= 48) break;
  }

  return out;
}

export const mockSearchData = {
  wikiPosts: buildWikiPosts(),
  siteCategories: [
    { id: "sc-dl", name: "Tải game & hướng dẫn cài", href: "/download", badge: "Cài đặt" },
    { id: "sc-vm", name: "Giả lập máy ảo", href: "/virtual-machine", badge: "Hướng dẫn" },
    { id: "sc-vps", name: "Máy chủ VPS", href: "/vps", badge: "Hạ tầng" },
    { id: "sc-acc", name: "Tạo tài khoản & gói khởi tạo", href: "/account", badge: "Tài khoản" },
    { id: "sc-pay", name: "Nạp point & giá", href: "/pricing", badge: "Thanh toán" },
    { id: "sc-tool", name: "Tool hỗ trợ game", href: "/tool", badge: "Tiện ích" },
    { id: "sc-news", name: "Tin & hướng dẫn trong web", href: "/news", badge: "Bài viết" },
    { id: "sc-list", name: "Danh sách tài khoản game", href: "/list-account", badge: "Quản lý" },
  ] as SiteCategorySearch[],
  highlights: [
    {
      id: "hi-wiki",
      name: "Kho wiki đầy đủ — tsorigin.com",
      href: wikiUrl("/bai-viet/"),
      badge: "Wiki",
      external: true,
    },
    {
      id: "hi-sup",
      name: "Hỗ trợ & câu hỏi thường gặp",
      href: "/support",
      badge: "Hỗ trợ",
    },
    {
      id: "hi-disc",
      name: "Thảo luận TS Origin",
      href: "/ts-origin-discussions",
      badge: "Cộng đồng",
    },
  ] as HighlightSearch[],
  pages: [
    { id: "p-home", title: "Trang chủ", path: "/" },
    { id: "p-acc", title: "Tạo tài khoản game", path: "/account" },
    { id: "p-dl", title: "Tải game", path: "/download" },
    { id: "p-vm", title: "Giả lập máy ảo", path: "/virtual-machine" },
    { id: "p-vps", title: "Máy chủ VPS", path: "/vps" },
    { id: "p-pay", title: "Gói & nạp point", path: "/pricing" },
    { id: "p-sup", title: "Hỗ trợ", path: "/support" },
    { id: "p-dash", title: "Bảng điều khiển người dùng", path: "/dashboard/user" },
    { id: "p-news", title: "Tin tức", path: "/news" },
    { id: "p-tool", title: "Tool hỗ trợ", path: "/tool" },
    { id: "p-list-acc", title: "Danh sách tài khoản", path: "/list-account" },
    { id: "p-creator-tips", title: "Mẹo & tính năng", path: "/creator-tips" },
    { id: "p-payment", title: "Thanh toán", path: "/payment" },
    { id: "p-explore", title: "Khám phá", path: "/explore" },
  ] as PageSearch[],
};
